export enum Events {
	NEWPAGE = 'onNewPage',
	PAGELOADED = 'onPageLoader',
	LOADINGPAGE = 'onLoadingPage',
	SAMEPAGE = 'samePage',
	TRANSITIONOUT = 'onTransitionOut',
	TRANSITIONIN = 'onTransitionIn',
	TRANSITIONDONE = 'onTransitionDone',
	BREAKPOINT = 'onBreakpoint',
	RESIZE = 'resize',
	REVEALED = 'revealed',

	// Mouse Events
	HIGHLIGHTCURSOR = 'highlightCursor',
	STANDARDCURSOR = 'standardCursor',
	LOADINGCURSOR = 'loadingCursor',
	FINISHEDLOADING = 'finishedLoading',
	HIDEMOUSE = 'hideMouse',
	SHOWMOUSE = 'showMouse',
}

export default class CustomEvents {
	public static dispatch(name: Events, data?: any) {
		var ev = new CustomEvent(name, data ? { detail: data } : null);

		// if (data) {
		// 	console.log(name, data);
		// } else {
		// 	console.log(name);
		// }

		window.dispatchEvent(ev);
	}

	public static listen(name: Events, fnc: (e: CustomEvent) => void) {
		window.addEventListener(name, fnc as EventListenerOrEventListenerObject);
	}

	public static remove(name: Events, fnc: (e: CustomEvent) => void) {
		window.removeEventListener(name, fnc as EventListenerOrEventListenerObject);
	}

	public static once(name: Events, fnc: (e: CustomEvent) => void) {
		var newFnc = (e: CustomEvent) => {
			fnc(e);
			CustomEvents.remove(name, newFnc);
		};

		CustomEvents.listen(name, newFnc);
	}
}
